import { Component, HostBinding, Input } from '@angular/core';

@Component({
    selector: 'app-page-header',
    templateUrl: './page-header.component.html',
    styleUrls: ['./page-header.component.scss']
})
export class PageHeaderComponent {
    @Input() backRouterLink: string[] | undefined;
    @Input() backLinkTooltip: string | undefined;
    @Input() showFilters = true;

    @HostBinding('class.sticky') @Input() sticky = true;

    toggleFilters(): void {
        this.showFilters = !this.showFilters;
    }
}

@Component({ selector: 'app-page-header-title', template: '<ng-content></ng-content>' })
export class PageTitleComponent {
}

@Component({ selector: 'app-page-header-subtitle', template: '<ng-content></ng-content>' })
export class PageSubtitleComponent {
}

@Component({ selector: 'app-page-header-info', template: '<ng-content></ng-content>' })
export class PageInfoComponent {
}
